import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL;

async function loadConfig() {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch (error) {
    console.error("Failed to load config.json. Using default .env API URL", error);
  }
}

loadConfig().then(() => {});

export async function assignCertificateToTenant(data:any){
  try {

      const response = await authService.apiCall(`${BASE_URL}/upload/assign_certificate`, {
          method: 'POST',
         
          body: data,
        
      });
      return response;
  } catch (error) {
      console.error('Error assigning certificate to tenant:', error);
      throw new Error('Error assigning certificate to tenant');
  }
}


export async function uploadFile(data:any) {
  try {
      const response = await authService.apiCall(`${BASE_URL}/upload/certificate`, {
          method: 'POST',
        
          body: data,
       
      });
      return response;
  } catch (error: any) {
      console.error('Error uploading file:', error);
      throw new Error('Error uploading file');
  }
}

export async function deleteCertification(id:any){
  try {
      const response = await authService.apiCall(`${BASE_URL}/certificates/${id}`, {
          method: 'DELETE',
         
      });

      if (!response.ok) {
          throw new Error('Failed to delete certifications');
      }

      const result = await response.json();
      return result;
  } catch (error) {
      console.error('Error deleting certifications:', error);
      throw new Error('Error deleting certifications');
  }
}

export async function getAllCertifications(query: string, perPage: number, pageNo: number) {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/certificates?query=${query}&perPage=${perPage}&pageNo=${pageNo}`,
      { method: 'GET' }
    );
    if (!response.ok) {
      throw new Error('Failed to fetch certifications');
    }
    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('Error fetching certifications:', error);
    throw new Error(error?.message || 'Error fetching certifications');
  }
}
